import { render, staticRenderFns } from "./loader-v3.component.vue?vue&type=template&id=35944f79&scoped=true&"
import script from "./loader-v3.component.vue?vue&type=script&lang=js&"
export * from "./loader-v3.component.vue?vue&type=script&lang=js&"
import style0 from "./loader-v3.component.vue?vue&type=style&index=0&id=35944f79&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35944f79",
  null
  
)

export default component.exports